'use strict';

var novicell = novicell || {};

novicell.tabSection = novicell.tabSection || new function () {
    this.init = function () {
        var navLink = [].slice.call(document.querySelectorAll('.tab-section-nav__item'));
        var panels = document.querySelectorAll('.tab-section-panel');
        var tabSectionOuter = document.querySelector('.tab-section-outer');

        navLink.map(function (item, index) {
            item.addEventListener('click', function () {
                document
                    .querySelector('.tab-section-nav__item--active')
                    .classList.remove('tab-section-nav__item--active');
                document
                    .querySelector('.tab-section-panel--active')
                    .classList.remove('tab-section-panel--active');
                item
                    .classList.add('tab-section-nav__item--active');
                panels[index]
                    .classList.add('tab-section-panel--active');
                tabSectionOuter
                    .style.height = panels[index].offsetHeight + 'px';
                document
                    .getElementById('tab-section-content')
                    .setAttribute('data-tab', index);
            });
        });
        var tabTitle = document.querySelector("#tab-section > ul > li.tab-section-nav__item.tab-section-nav__item:first-of-type > a");
        if(tabTitle) {
            setTimeout(function() {
                tabTitle.click();
            }, 100);
        }
    };
}();
